import { QarepaEnumInformation } from '@qarepa/common';

export enum WorkplacePoliciesEnum {
  NON_STRICT = 'NON_STRICT',
  RESTRICTED = 'RESTRICTED',
  STRICT = 'STRICT',
}

export const WorkspacePoliciesArray = [
  WorkplacePoliciesEnum.NON_STRICT,
  WorkplacePoliciesEnum.RESTRICTED,
  WorkplacePoliciesEnum.STRICT,
];

export const WorkplacePoliciesInfo: QarepaEnumInformation<WorkplacePoliciesEnum> =
  {
    [WorkplacePoliciesEnum.NON_STRICT]: {
      name: $localize`No Estricto`,
    },
    [WorkplacePoliciesEnum.RESTRICTED]: {
      name: $localize`Restringido`,
    },
    [WorkplacePoliciesEnum.STRICT]: {
      name: $localize`Estricto`,
    },
  };
